import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SyncService } from 'src/app/services/offline/sync.service';
import { ActivityLogService } from 'src/core/logging/activity-log.service';
import { FrontEventLogService } from 'src/core/logging/front-event-log.service';
import { ConnectivityLogService } from 'src/core/logging/connectivity-log.service';
import 'src/app/shared/pdf-canvas-viewer/pdfjs-worker-setup';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
  title = 'Transportistas';

  constructor(
    private titleService: Title,
    private syncService: SyncService,
    private frontEventLog: FrontEventLogService,
    private connectivityLog: ConnectivityLogService,
    private activityLog: ActivityLogService
  ) {
    this.titleService.setTitle(this.title);
  }

  ngOnInit() {
    this.frontEventLog.init();
    this.connectivityLog.init();
    this.activityLog.init();
    this.syncService.init();
  }
}
